import { render, staticRenderFns } from "./CommercialLogs.vue?vue&type=template&id=2ba51949"
import script from "./CommercialLogs.vue?vue&type=script&lang=js"
export * from "./CommercialLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports